<template>
  <section style="margin: 20px 0">
    <section class="calc-box-container">
      <!-- 左侧 -->
      <div class="calc-left">
        <div class="calc-box-left">
          <div class="text-box f-dir-c ai-center">
            <div class="label">油费总额</div>
            <div class="value">{{ dispatchInfo.oilSelfTotal }}</div>
          </div>
        </div>
        <!-- 间隔线 -->
        <div class="calc-box-separate"></div>
      </div>
      <!-- 右侧 -->
      <div class="calc-box-right">
        <div class="row-title">
          <span
            >总耗油量
            <span class="total-text">{{ dispatchInfo.oilLitreTotal }}</span>
            升</span
          >
        </div>
        <div class="calc-row-top">
          <div class="calc-price-box">
            <div class="text-box f-dir-c ai-center">
              <div class="label">油账户</div>
              <div class="value">{{ dispatchInfo.oilSelfVirtual }}</div>
            </div>
            <div class="text-box f-dir-c ai-center">
              <div class="label">总升数</div>
              <div class="value">{{ dispatchInfo.oilLitreVirtual }}</div>
            </div>
          </div>
          <div class="calc-row-box">
            <div
              class="calc-row"
              v-for="(chooseItem, index) in chooseList"
              :key="index"
            >
              <div class="row-content">
                <div class="row-box long">
                  <div class="text-box ai-center">
                    <div class="location-box">
                      <div class="location-value">
                        {{ chooseItem.oilDepotName || '请选择油站' }}
                        <ChooseLineOilDepotScheme
                          class="choose"
                          ref="choose1"
                          :isRadio="true"
                          :otherSearchData="otherSearchData"
                          @change="(item) => onChoose(item, index)"
                        />
                      </div>
                    </div>
                    <div class="amount-box">
                      <span class="amount-label">金额</span>
                      <span class="amount-value">{{
                        chooseItem.oilDepotFee
                      }}</span>
                    </div>
                  </div>
                </div>
                <div class="row-symbol">=</div>
                <div class="row-box normal">
                  <div class="text-box ai-center">
                    <div class="label">加油升数</div>
                    <div class="value">
                      <input
                        class="calc-chart-ipt"
                        type="text"
                        v-model="chooseItem.oilDepotLitre"
                        @blur="onChangeOilVolume($event, index)"
                      />
                    </div>
                  </div>
                </div>
                <div class="row-symbol">x</div>
                <div class="row-box normal">
                  <div class="text-box ai-center">
                    <div class="label">单价</div>
                    <div class="value">
                      <input
                        class="calc-chart-ipt"
                        type="text"
                        v-model="chooseItem.oilDepotPrice"
                        readonly
                      />
                      <span class="calc-chart-unit">元/升</span>
                    </div>
                  </div>
                </div>
                <div class="row-box normal row-margin">
                  <div class="text-box ai-center">
                    <div class="label">距靠台地</div>
                    <div class="value">
                      {{ chooseItem.distance }}
                    </div>
                  </div>
                </div>
                <div
                  class="row-box primary cur"
                  @click="removeChooseItem($event, index)"
                >
                  清除
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="calc-row-bottom">
          <div class="calc-price-box">
            <div class="text-box f-dir-c ai-center">
              <div class="label">油卡金额</div>
              <div class="value">{{ dispatchInfo.oilSelfEntity }}</div>
            </div>
          </div>
          <div class="calc-row-box">
            <div class="calc-row">
              <div class="row-content">
                <div class="row-box long">
                  <div class="text-box ai-center">
                    <div class="location-box">
                      <div class="location-value"></div>
                    </div>
                    <div class="amount-box">
                      <span class="amount-label">金额</span>
                      <span class="amount-value">{{
                        dispatchInfo.oilSelfEntity
                      }}</span>
                    </div>
                  </div>
                </div>
                <div class="row-symbol">=</div>
                <div class="row-box normal">
                  <div class="text-box ai-center">
                    <div class="label">油卡升数</div>
                    <div class="value">
                      <input
                        class="calc-chart-ipt"
                        type="text"
                        v-model="dispatchInfo.oilLitreEntity"
                        x
                      />
                    </div>
                  </div>
                </div>
                <div class="row-symbol">x</div>
                <div class="row-box normal">
                  <div class="text-box ai-center">
                    <div class="label">单价</div>
                    <div class="value">
                      <input
                        class="calc-chart-ipt"
                        type="text"
                        v-model="dispatchInfo.sysOilPrice"
                        @blur="onSysOilPriceChange"
                      />
                      <span class="calc-chart-unit">元/升</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="calc-box-container">
      <div class="calc-row" style="margin-left: 120px">
        <div class="row-content">
          <div class="row-box normal">
            <div class="text-box ai-center">
              <div class="label">预估成本</div>
              <div class="value">
                <input
                  class="calc-chart-ipt"
                  type="text"
                  v-model="dispatchInfo.estFee"
                  readonly
                />
              </div>
            </div>
          </div>
          <div class="row-symbol">=</div>
          <div class="row-box normal">
            <div class="text-box ai-center">
              <div class="label">补贴</div>
              <div class="value">
                <input
                  class="calc-chart-ipt"
                  type="text"
                  v-model="dispatchInfo.subsidyTotal"
                  readonly
                />
              </div>
            </div>
          </div>
          <div class="row-symbol">+</div>
          <div class="row-box normal">
            <div class="text-box ai-center">
              <div class="label">路桥费</div>
              <div class="value">
                <input
                  class="calc-chart-ipt"
                  type="text"
                  v-model="dispatchInfo.pontage"
                  readonly
                />
              </div>
            </div>
          </div>
          <div class="row-symbol">+</div>
          <div class="row-box normal">
            <div class="text-box ai-center">
              <div class="label">油费</div>
              <div class="value">
                <input
                  class="calc-chart-ipt"
                  type="text"
                  v-model="dispatchInfo.oilSelfTotal"
                  readonly
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <button @click="getDataTest" class="test-btn">测试提交参数</button>
  </section>
</template>

<script>
import {
  getFee,
} from 'api/operate';
import ChooseLineOilDepotScheme from 'components/choose/lineOilDepotScheme';
export default {
  components: {
    ChooseLineOilDepotScheme,
  },
  props: {
    chartData: {
      type: Object,
      default: () => ({}),
    },
    getFeeParams: {
      type: Object,
      default: () => (null),
    },
    paymentWay: {
      type: Number,
      default: 0,
    },
    appointWay: {
      type: Number,
      default: 3,
    },
  },
  data () {
    return {
      dispatchInfo: {
        // 总升数
        oilLitreVirtual: '0',
        // 油卡金额/金额
        oilSelfEntity: '0',
        // 主驾补贴
        userSubsidy: '0',
        // 副驾补贴
        copilotSubsidy: '0',
        // 切换司机补贴
        driverSwitchSubsidy: '0',
      },
      otherSearchData: {},
      chooseList: [
        {
          oilDepotName: '',
          oilDepotPrice: '0',
          oilDepotLitre: '0',
          oilDepotFee: '0.00',
        },
        {
          oilDepotName: '',
          oilDepotPrice: '0',
          oilDepotLitre: '0',
          oilDepotFee: '0.00',
        },
        {
          oilDepotName: '',
          oilDepotPrice: '0',
          oilDepotLitre: '0',
          oilDepotFee: '0.00',
        },
      ],
    };
  },
  methods: {
    async getDataTest () {
      const res = await this.sub();
      console.log('图表提交参数', res);
    },
    // 清除
    removeChooseItem (e, index) {
      this.chooseList[index] = {
        oilDepotName: '',
        oilDepotPrice: '0',
        oilDepotLitre: '0',
        oilDepotFee: '0.00',
      };
      this.chooseList[index].oilDepotName = '';
      this.chooseList[index].oilDepotPrice = '0';
      this.chooseList[index].oilDepotLitre = '0';
      this.chooseList[index].oilDepotFee = (this.chooseList[index].oilDepotLitre * this.chooseList[index].oilDepotPrice).toFixed(2);
      this.calcAllAgain();
    },
    // 重新计算
    calcAllAgain () {
      // 计算当前项的金额
      let oilSelfVirtual = 0;
      let oilLitreVirtual = 0;
      for (let itemNum of this.chooseList) {
        oilSelfVirtual += Number(itemNum.oilDepotFee);
        oilLitreVirtual += Number(itemNum.oilDepotLitre);
      }
      // 油账户 金额
      this.$set(this.dispatchInfo, 'oilSelfVirtual', oilSelfVirtual);
      // 总升数
      this.$set(this.dispatchInfo, 'oilLitreVirtual', oilLitreVirtual);
      // 重新计算 油卡升数
      this.$set(this.dispatchInfo, 'oilLitreEntity', this.dispatchInfo.oilLitreTotal - oilLitreVirtual);
      // 重新计算 油费总额
      this.$set(this.dispatchInfo, 'oilSelfEntity', (
        Number(this.dispatchInfo.oilLitreEntity) * Number(this.dispatchInfo.sysOilPrice)
      ).toFixed(2));
      // 油费总额 = 油卡金额 + 油账户
      this.$set(this.dispatchInfo, 'oilSelfTotal', (Number(this.dispatchInfo.oilSelfVirtual) + Number(this.dispatchInfo.oilSelfEntity)).toFixed(2));
      // 预估成本 = 补贴 + 路桥费 + 油费
      this.$set(this.dispatchInfo, 'estFee', (
        Number(this.dispatchInfo.subsidyTotal) +
        Number(this.dispatchInfo.pontage) +
        Number(this.dispatchInfo.oilSelfTotal)
      ));
    },
    // 切换油站
    onChoose (item, index) {
      const content = {
        ...this.chooseList[index],
        ...item,
      };
      console.log(item, index);
      this.$set(this.chooseList, index, content);
      // 油站名
      this.chooseList[index].oilDepotName = item.oilName;
      // 单价
      this.chooseList[index].oilDepotPrice = item.oilPrice;
      // 金额
      this.chooseList[index].oilDepotFee = (this.chooseList[index].oilDepotLitre * this.chooseList[index].oilDepotPrice).toFixed(2);
      this.calcAllAgain();
    },
    // 改变升数
    onChangeOilVolume (e, index) {
      this.chooseList[index].oilDepotFee = (this.chooseList[index].oilDepotLitre * this.chooseList[index].oilDepotPrice).toFixed(2);
      this.calcAllAgain();
    },
    // 改变单价
    onSysOilPriceChange () {
      this.calcAllAgain();
    },
    async setChartData (data) {
      this.dispatchInfo = data;
    },
    // 计算自有车费用
    async getFee (data) {

      // 重置所有之前选中的
      this.$set(this.dispatchInfo, 'oilLitreTotal', '0');
      this.$set(this.dispatchInfo, 'oilLitreEntity', '0');
      this.$set(this.dispatchInfo, 'sysOilPrice', '0');
      this.$set(this.dispatchInfo, 'pontage', '0');
      this.$set(this.dispatchInfo, 'oilSelfEntity', '0');
      this.$set(this.dispatchInfo, 'userSubsidy', '0');
      this.$set(this.dispatchInfo, 'copilotSubsidy', '0');
      this.$set(this.dispatchInfo, 'driverSwitchSubsidy', '0');
      this.$set(this.dispatchInfo, 'subsidyTotal', '0');

      for (let i = 0; i < this.chooseList.length; i++) {
        this.chooseList[i] = {
          oilDepotName: '',
          oilDepotPrice: '0',
          oilDepotLitre: '0',
          oilDepotFee: '0.00',
        };
      }

      const params = this.getFeeParams || data;
      this.otherSearchData = {
        isBill: 1,
        oilSelect: 1,
        productType: -1,
        flag: 'sale',
        lineId: params.lineId,
        sourceEand: params.eand,
        sourceNand: params.nand,
        desEand: params.desEand,
        desNand: params.desNand,
      };

      const resFee = await getFee(params);
      if (!resFee.failed) {
        // 油耗总量
        this.$set(this.dispatchInfo, 'oilLitreTotal', resFee.oilTotal);
        // 油卡升数
        this.$set(this.dispatchInfo, 'oilLitreEntity', resFee.oilTotal);
        // 单价
        this.$set(this.dispatchInfo, 'sysOilPrice', resFee.oilPrice / 100);
        // 路桥费
        this.$set(this.dispatchInfo, 'pontage', resFee.pontageFee / 100);
        // 油卡金额 = 油卡升数 * 单价
        this.$set(this.dispatchInfo, 'oilSelfEntity', (this.dispatchInfo.oilLitreEntity * this.dispatchInfo.sysOilPrice).toFixed(2));

        // 补贴计算

        // 主驾驶补贴
        this.$set(this.dispatchInfo, 'userSubsidy', (resFee.carDriverSubsidy ? (Number(resFee.carDriverSubsidy) / 100).toFixed(2) : this.dispatchInfo.userSubsidy));
        // 副驾驶补贴
        this.$set(this.dispatchInfo, 'copilotSubsidy', (resFee.copilotSubsidy ? (Number(resFee.copilotSubsidy) / 100).toFixed(2) : this.dispatchInfo.copilotSubsidy));
        // 切换司机补贴
        this.$set(this.dispatchInfo, 'driverSwitchSubsidy', (resFee.driverSwitchSubsidy ? (Number(resFee.driverSwitchSubsidy) / 100).toFixed(2) : this.dispatchInfo.driverSwitchSubsidy));
        // 总补贴
        this.$set(this.dispatchInfo, 'subsidyTotal', Number(this.dispatchInfo.userSubsidy) + Number(this.dispatchInfo.copilotSubsidy) + Number(this.dispatchInfo.driverSwitchSubsidy));

        // 油费总额 = 油卡金额 + 油账户
        this.$set(this.dispatchInfo, 'oilSelfTotal', (Number(this.dispatchInfo.oilSelfVirtual || '0') + Number(this.dispatchInfo.oilSelfEntity || '0')).toFixed(2));

        this.$set(this.dispatchInfo, 'estFee', (
          Number(this.dispatchInfo.subsidyTotal) +
          Number(this.dispatchInfo.pontage) +
          Number(this.dispatchInfo.oilSelfTotal)
        ));
      }
    },
    setCacheAndDetailData (data) {
      if (data.orderFeeExtDetail) {
        // 重置所有之前选中的
        this.$set(this.dispatchInfo, 'oilSelfTotal', data.totalOilFee / 100);
        this.$set(this.dispatchInfo, 'oilLitreTotal', data.orderFeeExtDetail.oilLitreTotal / 100);
        this.$set(this.dispatchInfo, 'oilLitreEntity', data.orderFeeExtDetail.oilLitreEntity / 100);
        this.$set(this.dispatchInfo, 'sysOilPrice', data.orderFeeExtDetail.oilPrice / 100);
        this.$set(this.dispatchInfo, 'pontage', data.orderFeeExtDetail.pontage / 100);
        this.$set(this.dispatchInfo, 'oilSelfEntity', data.orderFee.preOilFee / 100);
        this.$set(this.dispatchInfo, 'userSubsidy', data.orderFeeExtDetail.salary);
        this.$set(this.dispatchInfo, 'copilotSubsidy', data.orderFeeExtDetail.copilotSalary);
        this.$set(this.dispatchInfo, 'driverSwitchSubsidy', data.orderFeeExtDetail.driverSwitchSubsidy || 0);

        this.$set(this.dispatchInfo, 'subsidyTotal',
          Number(data.orderFeeExtDetail.salary / 100) +
          Number(data.orderFeeExtDetail.copilotSalary / 100) +
          Number(data.orderFeeExtDetail.driverSwitchSubsidy || 0)
        );

        if (data.schemes && data.schemes.length) {
          for (let i = 0; i < data.schemes.length; i++) {
            this.chooseList[i] = data.schemes[i];
            this.chooseList[i].oilId = data.schemes[i].oilDepotId;
            this.chooseList[i].oilDepotPrice = data.schemes[i].oilDepotPrice / 100;
            this.chooseList[i].oilDepotFee = data.schemes[i].oilDepotFee / 100;
            this.chooseList[i].distance = data.schemes[i].dependDistance / 100;
            this.chooseList[i].oilDepotLitre = data.schemes[i].oilDepotLitre / 100;
            this.chooseList[i].eand = data.schemes[i].oilDepotEand;
            this.chooseList[i].nand = data.schemes[i].oilDepotNand;
          }
        }
        this.calcAllAgain();
      }

      if (data.lineInfo) {
        this.otherSearchData = {
          isBill: 1,
          oilSelect: 1,
          productType: -1,
          flag: 'sale',
          lineId: data.lineInfo.lineId || '',
          sourceEand: data.lineInfo.sourceEand,
          sourceNand: data.lineInfo.sourceNand,
          desEand: data.lineInfo.desEand,
          desNand: data.lineInfo.desNand,
        };

      }
    },
    async sub () {
      const suffix = ['One', 'Two', 'Three'];
      for (let i = 0; i < this.chooseList.length; i++) {
        this.dispatchInfo['oilDepotId' + suffix[i]] = this.chooseList[i].oilId;
        this.dispatchInfo['oilDepotName' + suffix[i]] = this.chooseList[i].oilDepotName;
        this.dispatchInfo['oilDepotFee' + suffix[i]] = this.chooseList[i].oilDepotFee;
        this.dispatchInfo['dependDistance' + suffix[i]] = this.chooseList[i].distance;
        this.dispatchInfo['oilDepotPrice' + suffix[i]] = this.chooseList[i].oilDepotPrice;
        this.dispatchInfo['oilDepotLitre' + suffix[i]] = this.chooseList[i].oilDepotLitre;
        this.dispatchInfo['oilDepotEand' + suffix[i]] = this.chooseList[i].eand;
        this.dispatchInfo['oilDepotNand' + suffix[i]] = this.chooseList[i].nand;
      }
      this.dispatchInfo.oilPrice = this.dispatchInfo.sysOilPrice;
      return this.dispatchInfo;
    },
  },
};
</script>

<style lang="scss" scoped>
.calc-box-container {
  display: flex;
  align-items: center;
  .calc-left {
    display: flex;
    align-items: center;
    margin-top: 20px;
  }
  .text-box {
    font-size: 14px;
    border: 1px solid #ededed;
    border-radius: 2px;
    border-radius: 2px;
    padding: 10px;
    display: flex;
    &:nth-of-type(2) {
      margin-top: -1px;
    }
    &.f-dir-r {
      flex-direction: row;
    }
    &.f-dir-c {
      flex-direction: column;
    }
    &.jc-center {
      justify-content: center;
    }
    &.ai-center {
      align-items: center;
    }
    .label {
      color: #333333;
    }
    &:first-child {
      .value {
        .calc-chart-ipt {
          color: #ff5046;
        }
      }
    }
    .value {
      display: flex;
      .calc-chart-ipt {
        width: 50px;
        border: none;
        outline: none;
        margin-right: 10px;
        &:only-child {
          width: 50px;
        }
      }
      .calc-chart-unit {
      }
    }
  }
  .calc-box-left {
    max-width: 96px;
    padding: 5px 10px;
    .text-box {
      .label {
        padding-bottom: 4px;
      }
      .value {
        color: #ff5046;
        .calc-chart-ipt {
          width: 100%;
          margin-right: 0;
          text-align: center;
        }
      }
    }
  }
  .calc-box-separate {
    width: 9px;
    height: 160px;
    margin-left: 26px;
    position: relative;
    border: 1px solid #ededed;
    border-right: none;
    &:before {
      position: absolute;
      content: ' ';
      width: 0;
      height: 0;
      border-top: 7.5px solid transparent;
      border-right: 8px rgba(224, 233, 243, 1) solid;
      border-bottom: 7.5px solid transparent;
      top: 50%;
      left: -8px;
    }
    &:after {
      position: absolute;
      content: ' ';
      width: 0;
      height: 0;
      border-top: 8px solid transparent;
      border-right: 9px #fff solid;
      border-bottom: 6px solid transparent;
      top: 50%;
      left: -7px;
      z-index: 2;
    }
  }
  .calc-box-right {
    display: flex;
    flex-direction: column;
    .calc-price-box {
      margin: 0;
      width: 100px;
      .text-box {
        border: none;
        .label {
          padding-bottom: 4px;
        }
        .value {
          color: #ff5046;
        }
      }
    }
    .row-title {
      margin-bottom: 14px;
      text-align: center;
      .total-text {
        color: #ff5046;
        font-weight: bold;
      }
      :first-child {
        width: 174px;
      }
      :nth-last-child(1) {
        width: 180px;
        text-align: right;
      }
      :nth-last-child(2) {
        width: 300px;
        text-align: center;
      }
    }
    .calc-row-top,
    .calc-row-bottom {
      display: flex;
      flex-direction: row;
    }
    .calc-row-top {
      .calc-price-box {
        display: flex;
        flex-direction: column;
        justify-content: center;
      }
    }
    .calc-row-bottom {
      margin: 20px 0;
    }
  }
}
.calc-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  &:nth-of-type(2) {
    padding-top: 0;
  }
  .row-label {
    margin-left: 12px;
    margin-right: 24px;
  }
  .row-content {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding-top: 10px;
    .row-box {
      &.long {
        width: 250px;
      }
      &.normal {
        width: 150px;
      }
      &.row-margin {
        margin: 0 30px;
      }
      .text-box {
        display: flex;
        justify-content: space-between;
        cursor: pointer;
        position: relative;
        .location-box {
          .location-value {
            .choose {
              position: absolute;
              left: 0;
              top: 0;
              opacity: 0;
            }
          }
        }
        .amount-box {
          .amount-label {
          }
          .amount-value {
            color: #ff5046;
            padding-left: 10px;
          }
        }
        &:nth-of-type(2) {
          margin-top: -1px;
        }
      }
    }
    .row-symbol {
      font-size: 30px;
      color: #bcbbbb;
      margin: 0 22px;
    }
  }
}
.notice-color {
  color: #ff5046;
}
</style>
